import { useOrganization, useUser } from '@clerk/nextjs';
import { App } from '@web/query/App';
import { hasSubscription } from 'guards/Subscription';
import dynamic from 'next/dynamic';
import { useMemo } from 'react';

const ProductFruitsLib = dynamic(() => import('react-product-fruits').then((mod) => mod.ProductFruits), {
  ssr: false,
});

interface UserData {
  email?: string;
  firstname?: string;
  lastname?: string;
  username: string;
  role?: ClerkAuthorization['role'];
  signUpAt?: string;
  props: {
    userId: string;
    organization?: string;
    plan?: string;
  };
}

const ProductFruitsInitialize = () => {
  const { user } = useUser();
  const { data: subscriptionData, isLoading: subscriptionLoading } = App.useSubscriptions();
  const { organization, isLoaded: organizationLoaded } = useOrganization();
  const { data: configs } = App.useConfigs();

  const userData = useMemo(() => {
    if (user && organization) {
      const userId = user.id;
      const role = user.organizationMemberships[0].role;
      const email = user?.primaryEmailAddress?.emailAddress;
      const firstname = user?.firstName || undefined;
      const lastname = user?.lastName || undefined;
      const orgName = organization?.name;
      const plan =
        subscriptionData && hasSubscription(subscriptionData)
          ? subscriptionData.subscription.plan.metadata?.plan_name
          : undefined;
      const signUpAt = user?.createdAt ? new Date(user.createdAt).toISOString() : undefined;

      if (userId) {
        const data: UserData = {
          email,
          firstname,
          lastname,
          username: userId,
          role,
          signUpAt,
          props: {
            userId,
            organization: orgName,
            plan,
          },
        };
        return data;
      }
    }
  }, [user, organization, subscriptionData]);

  const workspaceCode = configs?.product_fruits_workspace_code;

  if (!userData?.username || !organizationLoaded || subscriptionLoading || !workspaceCode) {
    return null;
  }

  return (
    <>
      {typeof window !== 'undefined' && userData.username ? (
        <ProductFruitsLib workspaceCode={workspaceCode} language="en" user={userData} />
      ) : null}
    </>
  );
};

export { ProductFruitsInitialize };
